import React from 'react';
import styles from './DemoCompanyPage.module.css';

// Forest Hill logo and product data
const FOREST_HILL_LOGO = "https://foresthillco.in/cdn/shop/files/forestHill-logof.png?v=1688142810&width=170";

const FOREST_HILL_PRODUCTS = [
  {
    id: 1,
    name: "Pre Shave Oil - 50 ml",
    price: "₹599",
    image: "https://foresthillco.in/cdn/shop/files/B3D42E18-D7B6-4D9F-8980-A7AC1FDB6493.jpg?v=1685632875&width=600",
    description: "A nourishing blend of natural oils to prep and protect your skin for a smooth, irritation-free shave.",
    category: "Shave",
    featured: true
  },
  {
    id: 2,
    name: "Ashford Shaving Brush",
    price: "₹1,279",
    image: "https://foresthillco.in/cdn/shop/files/4_black.jpg?v=1747814689&width=600",
    description: "Premium shaving brush for a rich lather and gentle exfoliation. Available in multiple colors.",
    category: "Shave",
    featured: true
  },
  {
    id: 3,
    name: "Aqua Shaving Cream - 75g",
    price: "₹279 – ₹499",
    image: "https://foresthillco.in/cdn/shop/files/ForestHill0004.jpg?v=1700126932&width=600",
    description: "Soft, moisturizing shaving cream with a fresh fragrance for a smooth, comfortable shave.",
    category: "Shave",
    featured: true
  },
  {
    id: 4,
    name: "Beard Oil - 50ml",
    price: "₹599",
    image: "https://foresthillco.in/cdn/shop/files/5E5729E2-56B3-4BCA-B20E-25E0309A98B6.jpg?v=1685632431&width=600",
    description: "Nourishing beard oil to soften, thicken, and add shine to your beard.",
    category: "Beard",
    featured: true
  },
  {
    id: 5,
    name: "Hydrating Lip Balm - 10g",
    price: "₹280",
    image: "https://foresthillco.in/cdn/shop/files/3B641A7A-7B48-492C-ABBA-E00A8016B1F0.jpg?v=1685632780&width=600",
    description: "Coconut & vanilla lip balm with SPF and white tea oil for all-day hydration.",
    category: "Face & Lip",
    featured: true
  },
  {
    id: 6,
    name: "Taiga Eau De Parfum - 10ml",
    price: "₹400",
    image: "https://foresthillco.in/cdn/shop/files/3FE50AD8-F8F2-476D-BAC9-B3E98F2F9BCC.jpg?v=1741003768&width=600",
    description: "A sophisticated, travel-friendly fragrance inspired by the wild Taiga forests.",
    category: "Fragrance",
    featured: true
  },
  {
    id: 7,
    name: "De Tan Face Mask - 100 gms",
    price: "₹449",
    image: "https://foresthillco.in/cdn/shop/files/Detanfacemask_2.jpg?v=1697885337&width=600",
    description: "Detan face mask to brighten and refresh your skin after sun exposure.",
    category: "Face & Lip",
    featured: false
  },
  {
    id: 8,
    name: "Ashford Shaving Brush + Stand Set",
    price: "₹1,999",
    image: "https://foresthillco.in/cdn/shop/files/black.jpg?v=1749464321&width=600",
    description: "Complete shaving brush and stand set for a premium grooming experience.",
    category: "Shave",
    featured: false
  }
];

const CATEGORIES = [
  "Shave",
  "Beard",
  "Face & Lip",
  "Fragrance"
];

// Banner images for carousel (desktop and mobile)
const BANNER_IMAGES = [
  {
    desktop: "https://foresthillco.in/cdn/shop/files/Desktop_Website_Banners_FH_-_4.jpg?v=1689094793",
    mobile: "https://foresthillco.in/cdn/shop/files/Mobile_Website_Banners_FH_f13dba30-3748-487f-b83c-71b24a934256.jpg?v=1741158030",
    link: "https://blinkit.com/brand/forest-hill/23921"
  },
  {
    desktop: "https://foresthillco.in/cdn/shop/files/Desktop_Website_Banners_FH_-_6.jpg?v=1689094793",
    mobile: "https://foresthillco.in/cdn/shop/files/Ashford_Kit_Website_Banner_2_jpg.jpg?v=1741249908",
    link: "/products/hair-clay-20-gms"
  },
  {
    desktop: "https://foresthillco.in/cdn/shop/files/Desktop_Website_Banners_FH_-_3.jpg?v=1689094793",
    mobile: "https://foresthillco.in/cdn/shop/files/Mobile_Website_Banners_FH_2.jpg?v=1741159606",
    link: "/collections/fragnance"
  },
  {
    desktop: "https://foresthillco.in/cdn/shop/files/Desktop_Website_Banners_FH_-_1.jpg?v=1689094793",
    mobile: "https://foresthillco.in/cdn/shop/files/Ashford_Kit_Website_Banner_jpg.jpg?v=1741245091",
    link: ""
  },
  {
    desktop: "https://foresthillco.in/cdn/shop/files/Desktop_Website_Banners_FH_-_5.jpg?v=1689094794",
    mobile: "https://foresthillco.in/cdn/shop/files/ShaveRegimenBanner.jpg?v=1718878935",
    link: ""
  }
];

function BannerCarousel() {
  const [index, setIndex] = React.useState(0);
  React.useEffect(() => {
    const timer = setInterval(() => {
      setIndex(i => (i + 1) % BANNER_IMAGES.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const banner = BANNER_IMAGES[index];
  // Responsive image: show mobile on small screens, desktop otherwise
  return (
    <div className={styles.bannerSection}>
      {banner.link ? (
        <a href={banner.link} target="_blank" rel="noopener noreferrer" style={{display:'block', width:'100%'}}>
          <picture style={{display:'block', width:'100%'}}>
            <source media="(max-width: 767px)" srcSet={banner.mobile} />
            <img
              src={banner.desktop}
              alt="Forest Hill Banner"
              className={styles.bannerImage}
              style={{
                width: '100%',
                maxWidth: '100vw',
                height: 'auto',
                maxHeight: '340px',
                objectFit: 'cover',
                borderRadius: '16px',
                boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
              }}
            />
          </picture>
        </a>
      ) : (
        <picture style={{display:'block', width:'100%'}}>
          <source media="(max-width: 767px)" srcSet={banner.mobile} />
          <img
            src={banner.desktop}
            alt="Forest Hill Banner"
            className={styles.bannerImage}
            style={{
              width: '100%',
              maxWidth: '100vw',
              height: 'auto',
              maxHeight: '340px',
              objectFit: 'cover',
              borderRadius: '16px',
              boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
            }}
          />
        </picture>
      )}
      <div className={styles.bannerDots}>
        {BANNER_IMAGES.map((_, i) => (
          <span
            key={i}
            className={i === index ? styles.bannerDotActive : styles.bannerDot}
            onClick={() => setIndex(i)}
            aria-label={`Go to banner ${i+1}`}
            role="button"
            tabIndex={0}
            style={{cursor:'pointer'}}
          />
        ))}
      </div>
      <style>{`
        @media (max-width: 767px) {
          .${styles.bannerImage} {
            max-height: 180px !important;
          }
        }
      `}</style>
    </div>
  );
}

function DemoCompanyPage() {
  const [searchTerm, setSearchTerm] = React.useState("");

  // Filter products by search term (name or description)
  const filteredProducts = FOREST_HILL_PRODUCTS.filter(
    p =>
      p.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={styles.companyPageContainer}>
      <div className={styles.heroSection}>
        <img src={FOREST_HILL_LOGO} alt="Forest Hill Logo" className={styles.companyLogo} />
        <div className={styles.heroText}>
          <h1>Forest Hill</h1>
          <p>Upcycled. Sustainable. Stylish.</p>
        </div>
      </div>
      {/* Banner Carousel Section */}
      <BannerCarousel />
      <div className={styles.companyInfoSection}>
        <div className={styles.companyDescription}>
          <div className={styles.infoHeaderRow} style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%',flexWrap:'nowrap',gap:'2rem'}}>
            <h2 style={{margin:0,flex:'1 1 0%',minWidth:0,whiteSpace:'nowrap'}}>About Forest Hill</h2>
            <input
              type="text"
              placeholder="Search products..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              className={styles.searchBox}
              aria-label="Search products"
              autoComplete="off"
              spellCheck={false}
              style={{
                border: '1.5px solid #388e3c',
                borderRadius: '24px',
                fontSize: '1.08rem',
                height: '2.7rem',
                background: '#f8faf8',
                boxShadow: '0 2px 8px rgba(56,142,60,0.06)',
                transition: 'border-color 0.2s, box-shadow 0.2s',
                maxWidth: '400px',
                minWidth: '180px',
                width: '100%',
                paddingLeft: '1rem',
                marginLeft: 'auto',
                flexShrink: 0
              }}
            />
          </div>
          <p>
            Forest Hill crafts premium bags and accessories from upcycled and recycled materials. Each product is designed for durability, style, and sustainability. Join us in making a positive impact on the planet—one bag at a time.
          </p>
          <ul>
            <li>♻️ Upcycled & Recycled Materials</li>
            <li>🌱 Eco-conscious Manufacturing</li>
            <li>⭐ 4.9/5 Customer Rating</li>
          </ul>
        </div>
      </div>
      <div className={styles.productsSection}>
        <h2>Featured Products</h2>
        <div className={styles.productsGrid}>
          {filteredProducts.filter(p=>p.featured).map(product => (
            <div key={product.id} className={styles.productCard}>
              <img src={product.image} alt={product.name} className={styles.productImage} />
              <div className={styles.productInfo}>
                <h4>{product.name}</h4>
                <p>{product.description}</p>
                <div className={styles.productPrice}>{product.price}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.productsSection}>
        <h2>Shop by Category</h2>
        {CATEGORIES.map(category => (
          <div key={category} style={{marginBottom:'2rem'}}>
            <h3 style={{color:'#004443',marginBottom:'1rem'}}>{category}</h3>
            <div className={styles.productsGrid}>
              {filteredProducts.filter(p=>p.category===category).map(product => (
                <div key={product.id} className={styles.productCard}>
                  <img src={product.image} alt={product.name} className={styles.productImage} />
                  <div className={styles.productInfo}>
                    <h4>{product.name}</h4>
                    <p>{product.description}</p>
                    <div className={styles.productPrice}>{product.price}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.testimonialsSection}>
        <h2>What Our Customers Say</h2>
        <TestimonialCarousel />
      </div>
    </div>
  );
}

export default DemoCompanyPage;

// Testimonials data for carousel
const TESTIMONIALS = [
  {
    message: "The upcycled backpack is sturdy and stylish. Love the eco-friendly mission!",
    author: "Aditi R."
  },
  {
    message: "Forest Hill's laptop sleeve is both protective and sustainable. Highly recommend!",
    author: "Karan S."
  },
  // Add more testimonials here if desired
];

function TestimonialCarousel() {
  const [index, setIndex] = React.useState(0);
  React.useEffect(() => {
    const timer = setInterval(() => {
      setIndex(i => (i + 1) % TESTIMONIALS.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  return (
    <div className={styles.testimonialsGrid}>
      <div className={styles.testimonialCard}>
        <p>"{TESTIMONIALS[index].message}"</p>
        <span>- {TESTIMONIALS[index].author}</span>
      </div>
      <div className={styles.testimonialDots}>
        {TESTIMONIALS.map((_, i) => (
          <span
            key={i}
            className={i === index ? styles.bannerDotActive : styles.bannerDot}
            onClick={() => setIndex(i)}
            aria-label={`Go to testimonial ${i+1}`}
            role="button"
            tabIndex={0}
            style={{cursor:'pointer', margin:'0 4px'}}
          />
        ))}
      </div>
    </div>
  );
}
